@let blok = block();

@if (blok?.text) {
    <p class="text-base text-grey-light">{{ blok.text }}</p>
}
@if (blok?.price) {
    <p class="text-2xl font-bold text-accent-light">{{ blok.price }} €</p>
}
<p class="text-white text-lg font-bold capitalize">{{ blok?.pro || 'Monat' }}</p>
